import React, { useState, useEffect } from 'react'
import { Card, message, Typography, Tag, DatePicker, Select, Space } from 'antd'
import AdminTable from '../../components/common/AdminTable'
import api from '../../utils/api'
import { formatTz } from '../../utils/timezone'

const { Title } = Typography
const { Option } = Select

const BookingsList = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10
  })
  const [filters, setFilters] = useState({
    status: undefined,
    date: undefined
  })

  const columns = [
    {
      title: '店家名稱',
      dataIndex: 'businessName',
      key: 'businessName'
    },
    {
      title: '客戶名稱',
      dataIndex: 'userName',
      key: 'userName'
    },
    {
      title: '預約日期',
      dataIndex: 'date',
      key: 'date'
    },
    {
      title: '預約時間',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '狀態',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const statusColors = {
          confirmed: 'success',
          pending: 'warning',
          cancelled: 'error'
        }
        return <Tag color={statusColors[status] || 'default'}>{status}</Tag>
      }
    },
    {
      title: '折扣後價格',
      dataIndex: 'discountedPrice',
      key: 'discountedPrice',
      render: (price) => `NT$ ${price}`
    },
    {
      title: '建立時間',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => formatTz(date, 'YYYY/MM/DD')
    }
  ]

  const fetchData = async (page = 1, pageSize = 10) => {
    setLoading(true)
    try {
      const params = new URLSearchParams({
        page: page,
        limit: pageSize,
        ...(filters.status && { status: filters.status }),
        ...(filters.date && { date: filters.date })
      })

      const response = await api.get(`/api/admin/bookings?${params}`)
      setData(response.data.data)
      setPagination(response.data.pagination)
    } catch (error) {
      message.error('獲取預約數據失敗')
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [filters])

  const handleTableChange = (pagination) => {
    fetchData(pagination.current, pagination.pageSize)
  }

  const handleFilterChange = (type, value) => {
    setFilters((prev) => ({
      ...prev,
      [type]: value
    }))
  }

  return (
    <Card>
      <Title level={2}>預約管理</Title>

      <Space style={{ marginBottom: 16 }}>
        <DatePicker
          onChange={(date, dateString) =>
            handleFilterChange('date', dateString)
          }
          placeholder='選擇日期'
        />
        <Select
          placeholder='預約狀態'
          style={{ width: 120 }}
          onChange={(value) => handleFilterChange('status', value)}
          allowClear
        >
          <Option value='confirmed'>已確認</Option>
          <Option value='pending'>待確認</Option>
          <Option value='cancelled'>已取消</Option>
        </Select>
      </Space>

      <AdminTable
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </Card>
  )
}

export default BookingsList
